export default __webpack_public_path__ + "static/media/washu.6d3ddf8e.png";